import { createElement, forwardRef } from "react";

import type { TextProps } from "@/components/types";
import type { JSX } from "react";

const Text = forwardRef<HTMLElement, TextProps>(
  ({ children, type = "span", ...props }, ref): JSX.Element =>
    createElement(type, { ...props, ref }, children)
);

Text.displayName = "Text";

export default Text;
